const LogoIconFullColor = () => {
  const imageUrl = "/assets/erniee-logo-full-colour.svg";

  return (
    <div className="logo-wrapper">
      <img src={imageUrl} alt="erniee.ai" />
    </div>
  );
};

export default LogoIconFullColor;
